import { Component } from '@angular/core';

@Component({
  selector: 'eiq-table-skeleton',
  templateUrl: 'table-skeleton.component.html',
  styleUrls: ['table-skeleton.component.scss']
})
export class TableSkeletonComponent {}
